import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly mediaplanType?: Types.AccountsCompanyMediaplanType | null, readonly tokens: ReadonlyArray<{ readonly __typename?: 'OauthProviderToken', readonly provider: Types.OauthProvider }>, readonly unfinishedMediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly budget: number, readonly startOn: string, readonly repeat?: Types.AccountsMediaplanRepeat | null, readonly type: Types.AccountsMediaplanType, readonly endOn?: string | null, readonly startOnPeriodBegin?: boolean | null, readonly kpis?: ReadonlyArray<{ readonly __typename?: 'AccountsKpi', readonly name: Types.AccountsKpiName, readonly primary: boolean, readonly value: string | number }> | null }>, readonly kpiSettings: { readonly __typename?: 'YalperKpiSettings', readonly attributionModel?: Types.YalperAnalyticAttributionModelEnum | null, readonly goals: ReadonlyArray<number>, readonly revenueGoalId?: number | null } } | null } | null };

export type GetAnalyticGoalsQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type GetAnalyticGoalsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly analyticGoals: ReadonlyArray<{ readonly __typename?: 'YalperAnalyticGoal', readonly id: number, readonly isEcomm: boolean, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null } | null };

export type GetCompanyMediaplansQueryVariables = Types.Exact<{
  companyId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  startDate: Types.Scalars['Date']['input'];
  endDate: Types.Scalars['Date']['input'];
}>;


export type GetCompanyMediaplansQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly mediaplans: ReadonlyArray<{ readonly __typename?: 'AccountsMediaplan', readonly id: string, readonly startOn: string, readonly endOn?: string | null, readonly type: Types.AccountsMediaplanType, readonly repeat?: Types.AccountsMediaplanRepeat | null }> } | null } | null };


export const GetCurrentUserDocument = gql`
    query GetCurrentUser($companyId: ID) {
  currentUser {
    company(id: $companyId) {
      id
      mediaplanType
      tokens {
        provider
      }
      unfinishedMediaplans {
        id
        budget
        startOn
        repeat
        type
        endOn
        startOnPeriodBegin
        kpis {
          name
          primary
          value
        }
      }
      kpiSettings {
        attributionModel
        goals
        revenueGoalId
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;
export const GetAnalyticGoalsDocument = gql`
    query GetAnalyticGoals($companyId: ID) {
  currentUser {
    company(id: $companyId) {
      analyticGoals(companyId: $companyId) {
        id
        isEcomm
        name
        counterId
        counterName
      }
    }
  }
}
    `;

/**
 * __useGetAnalyticGoalsQuery__
 *
 * To run a query within a React component, call `useGetAnalyticGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalyticGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalyticGoalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetAnalyticGoalsQuery(baseOptions?: Apollo.QueryHookOptions<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>(GetAnalyticGoalsDocument, options);
      }
export function useGetAnalyticGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>(GetAnalyticGoalsDocument, options);
        }
export function useGetAnalyticGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>(GetAnalyticGoalsDocument, options);
        }
export type GetAnalyticGoalsQueryHookResult = ReturnType<typeof useGetAnalyticGoalsQuery>;
export type GetAnalyticGoalsLazyQueryHookResult = ReturnType<typeof useGetAnalyticGoalsLazyQuery>;
export type GetAnalyticGoalsSuspenseQueryHookResult = ReturnType<typeof useGetAnalyticGoalsSuspenseQuery>;
export type GetAnalyticGoalsQueryResult = Apollo.QueryResult<GetAnalyticGoalsQueryPage, GetAnalyticGoalsQueryVariables>;
export const GetCompanyMediaplansDocument = gql`
    query GetCompanyMediaplans($companyId: ID, $startDate: Date!, $endDate: Date!) {
  currentUser {
    company(id: $companyId) {
      id
      mediaplans(startDate: $startDate, endDate: $endDate) {
        id
        startOn
        endOn
        type
        repeat
      }
    }
  }
}
    `;

/**
 * __useGetCompanyMediaplansQuery__
 *
 * To run a query within a React component, call `useGetCompanyMediaplansQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyMediaplansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyMediaplansQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetCompanyMediaplansQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables> & ({ variables: GetCompanyMediaplansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>(GetCompanyMediaplansDocument, options);
      }
export function useGetCompanyMediaplansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>(GetCompanyMediaplansDocument, options);
        }
export function useGetCompanyMediaplansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>(GetCompanyMediaplansDocument, options);
        }
export type GetCompanyMediaplansQueryHookResult = ReturnType<typeof useGetCompanyMediaplansQuery>;
export type GetCompanyMediaplansLazyQueryHookResult = ReturnType<typeof useGetCompanyMediaplansLazyQuery>;
export type GetCompanyMediaplansSuspenseQueryHookResult = ReturnType<typeof useGetCompanyMediaplansSuspenseQuery>;
export type GetCompanyMediaplansQueryResult = Apollo.QueryResult<GetCompanyMediaplansQueryPage, GetCompanyMediaplansQueryVariables>;